import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { addAdmin } from "../../services/users/Admins";

const CreateAdminModal = ({ open, onClose, setLoading }) => {
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    userName: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Limpiar errores al escribir
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      // Validación simple
      setLoading(true);
      let valid = true;
      const newErrors = { userName: "", password: "" };

      if (!formData.userName.trim()) {
        newErrors.userName = "El nombre de usuario es requerido";
        valid = false;
      }

      if (!formData.password) {
        newErrors.password = "La contraseña es requerida";
        valid = false;
      } else if (formData.password.length < 6) {
        newErrors.password = "La contraseña debe tener al menos 6 caracteres";
        valid = false;
      }

      setErrors(newErrors);

      if (valid) {
        await addAdmin(formData);
        // Limpiar el formulario después de enviar
        setFormData({ userName: "", password: "" });
        onClose();
        toast.success("Usuario creado con éxito.");
      }
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`No se pudo crear el Admin. \n ${message}`);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Crear Nuevo Usuario Admin</DialogTitle>
      <DialogContent>
        <TextField
          margin="normal"
          fullWidth
          label="Nombre de Usuario"
          name="userName"
          value={formData.userName}
          onChange={handleChange}
          error={!!errors.userName}
          helperText={errors.userName}
          autoFocus
        />

        <FormControl
          fullWidth
          variant="outlined"
          margin="normal"
          error={!!errors.password}
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Contraseña
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Contraseña"
          />
          {errors.password && (
            <FormHelperText>{errors.password}</FormHelperText>
          )}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="#e7ef7d">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Crear Usuario
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAdminModal;
